import React, { FunctionComponent } from 'react';
import { UploadItem } from '@vwfs-bronson/bronson-react';
import { StipulationFileRecord } from '../../../types/files';
import { getFileExtension } from '../utils';

export type FileUploadItemProps = {
  files?: StipulationFileRecord[];
  removeFile: (id: string) => void;
  downloadFile?: (id: string) => void;
  progressValue?: string;
  // fileSizeFormatter: (bytes: number) => string;
  isSuccess?: boolean;
  hasError?: boolean;
  canDelete?: boolean;
};

export const FileUploadItems: FunctionComponent<FileUploadItemProps> = ({
  files,
  removeFile,
  downloadFile,
  progressValue = '100',
  isSuccess = false,
  hasError = false,
  canDelete = true,
}) => {
  if (!files?.length) {
    return null;
  }
  return (
    <>
      {files?.map(({ name, id }) => {
        const type = getFileExtension(name);
        return (
          <UploadItem
            error={hasError}
            className="u-mb-small"
            // eslint-disable-next-line react/no-array-index-key
            key={`${name}_${id}`}
            icon="semantic-file"
            fileName={name}
            fileType={type}
            onMainButtonClick={(): void => downloadFile && downloadFile(id)}
            onSecondaryButtonClick={canDelete ? (): void => removeFile(id) : undefined}
            hideSecondaryButton={!canDelete}
            progressValue={progressValue}
            success={isSuccess}
          />
        );
      })}
    </>
  );
};
